<template>
  <div class="login_box">
    <el-row
      :span="24"
      v-on:keyup.native.enter="submit"
      type="flex"
      justify="center"
    >
      <el-col
        :span="24"
        style="margin-top:5%"
      >
        <div class="constractor_top" style="margin: 50px;font-size: 16px;">
          <h1>苏 </nbsp>州 </nbsp>数 </nbsp>字 </nbsp>化 </nbsp>审 </nbsp>图 </nbsp>系 </nbsp>统</h1>
        </div>
        <div style="display: flex;width:100%; "> 
          <div style="display: flex;width:50%;justify-content: right;align-items: right;"
        >
              <img
                src="../../../assets/img.png"
                alt=""
                style="width:432px; height:440px;"
              />
        </div>
          <div
          class="login"
          style="float:left;"
        >
          <h1 style="margin-bottom: 20px;color: rgb(101 103 105);font-size: 22px;">{{ title }}</h1>
          <el-form
            ref="loginRef"
            :model="login"
            :rules="rules"
          >
            <el-form-item prop="username">
              <img
                src="../../../assets/usernam_icon.png"
                alt=""
                class="username_position"
              />
              <el-input
                placeholder="用户名"
                v-model="login.username"
                class="directive_input_style"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <img
                src="../../../assets/password_icon.png"
                alt=""
                class="username_position"
              />
              <el-input
                type="password"
                placeholder="密码"
                v-model="login.password"
                class="directive_input_style"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item prop="">
							<el-input type="password" placeholder="验证码"></el-input>
						</el-form-item>-->
            <el-form-item>
              <el-row style="text-align: right">
                <el-button
                  type="text"
                  @click="show_reset_password"
                  style="color: #8F8F8F;"
                  ><img
                    src="../../../assets/forget_icon.png"
                    alt=""
                    style="width: 20%;vertical-align: middle;"
                  />
                  忘记密码</el-button
                >
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-button
                    type="primary"
                    style="width: 98%"
                    v-loading.fullscreen.lock="loading"
                    @click="submit"
                    >登录</el-button
                  >
                </el-col>
                <!-- <p class="constractor_footer">
									|&nbsp;&nbsp;&nbsp;&nbsp;办事指南&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;常见问题&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;参考视频&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;参照手册&nbsp;&nbsp;&nbsp;|
								</p> -->
                <!-- <el-col :span="12" >
									<el-button type="primary" style="width: 98%" @click="register()" :disabled='true'>注册</el-button>
								</el-col> -->
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-button type="text" @click="guidance">办事指南</el-button>
                </el-col>
                <el-col :span="6">
                  <el-button type="text" @click="question">常见问题</el-button>
                </el-col>
                <el-col :span="6">
                  <el-button type="text" @click="video">参考视频</el-button>
                </el-col>
                <el-col :span="6">
                  <el-button type="text" @click="handbook">参照手册</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </div>
        </div>
        <div style="height:130px;margin: 0 auto;padding-top:100px;color: #282C37;    position: relative;text-alignt:bottom;">
          <p>苏州市住房和城乡建设局</p>
        </div>
      </el-col>
    </el-row>
    <!-- 修改密码 -->
    <el-dialog
      :title="reset.title"
      :visible.sync="reset.visible"
      :before-close="reset_close"
    >
      <el-form
        label-width="120px"
        label-position="right"
        ref="resetRef"
        :model="reset.data"
        :rules="reset.rules"
        class="demo-form-inline"
      >
        <el-row>
          <el-col>
            <el-form-item label="账号：" prop="userIdentity">
              <el-input
                placeholder="账号"
                v-model="reset.data.userIdentity"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="手机号码:" prop="phone">
              <el-input
                v-model="reset.data.userInfoMobile"
                :disabled="mon_count"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="验证码:" prop="verificationCode">
            <el-col :span="18">
              <el-input v-model="reset.data.verificationCode"></el-input>
            </el-col>
            <el-col :span="6">
              <el-button
                type="primary"
                :disabled="regphone || mon_count"
                @click="auth_code"
                >{{ mon_count ? count_down + "s" : "获取验证码" }}</el-button
              >
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="新密码:" prop="passwd">
              <el-input
                type="password"
                v-model="reset.data.password"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="确认密码:" prop="checkPass">
              <el-input
                type="password"
                v-model="reset.checkpassword"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="20">
          <el-col :span="20">
            <el-form-item>
              <el-button type="primary" @click="reset_submit">保 存</el-button>
              <el-button @click="reset_close">取 消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import cryptoObj from "../../../jiami/index.js";

export default {
  mounted() {
    this.query_config();
    if (this.$route.query.Type === "drawing") {
      this.title = "审图机构";
      this.reset.title = "审查机构修改密码";
      this.imgUrl = require("../../../assets/constractor_logo3.png");
    } else if (this.$route.query.Type === "supervise") {
      this.title = "主管部门";
      this.reset.title = "主管部门修改密码";
      this.imgUrl = require("../../../assets/constractor_logo5.png");
    }
    document
      .querySelector("body")
      .setAttribute(
        "style",
        "background-image:url(" +
          require("../../../assets/bg-index.png") +
          ");background-size: cover;background-position: center bottom;background-repeat: no-repeat;background-attachment: fixed;"
      );
  },
  data() {
    var checkpass = (rule, value, callback) => {
      if (this.reset.checkpassword === "") {
        callback(new Error("请再次输入密码"));
      } else if (this.reset.checkpassword !== this.reset.data.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var pass = (rule, value, callback) => {
      var tt = /^(?=^.{8,}$)(?=(?:.*?\d){1})(?=.*[a-z])(?=(?:.*?[A-Z]){1})(?=(?:.*?[@#$&.]){1})(?!.*\s)[0-9a-zA-Z@#$&\.]*$/; //不能全是数学和特殊字符.
      if (this.reset.data.password === "") {
        callback(new Error("请输入密码"));
      } else if (!tt.test(this.reset.data.password)) {
        callback(
          new Error(
            "密码必须是 大写字母，小写字母，特殊字符(包含 . @ # $ & )、数字 等其中任意四种类型或四种类型以上组合，且不能少于8位"
          )
        );
      } else {
        callback();
      }
    };
    var phone = (rule, value, callback) => {
      var reg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (this.reset.data.userInfoMobile == "") {
        callback(new Error("请输入手机号码"));
      } else if (!reg.test(this.reset.data.userInfoMobile)) {
        callback(new Error("手机格式不正确"));
      } else {
        callback();
      }
    };
    return {
      title: "",
      upload: "/censor/att/upload",
      loading: false,
      login: {
        username: "",
        password: "",
        type: "审查机构"
      },
      loginPlaceholder: "组织机构代码",
      reset: {
        title: "",
        visible: false,
        checkpassword: "",
        data: {
          // organizationCode:'',
          userIdentity: "",
          userInfoMobile: "",
          password: "",
          verificationCode: ""
        },
        loading: true,
        rules: {
          userIdentity: [
            { required: true, message: "请输入组织机构代码", trigger: "blur" }
          ],
          checkPass: [
            {
              validator: checkpass,
              trigger: "blur"
            }
          ],
          passwd: [
            {
              validator: pass,
              trigger: "blur"
            }
          ],
          phone: [{ validator: phone, trigger: "blur" }]
        }
      },
      rules: {
        username: [
          { required: true, message: "请输入您的用户名", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入您的密码", trigger: "blur" }
        ]
      },
      url: {
        login: "/draw/login",
        censor: "/censor/login",
        design: "/design/login",
        draw: "/draw/login",
        sms: "/censor/sms/send2",
        sysFunctionsIntroduce: "/draw/sysFunctionsIntroduce",
        censor_reset_password: "/censor/constructioncorp/password",
        design_reset_password: "/design/designcorp/password",
        reset_password: "/draw/userinfo/password"
      },
      count_down: 0, //倒计时
      reg: false
    };
  },
  computed: {
    regphone() {
      let reg = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
      if (reg.test(this.reset.data.userInfoMobile)) {
        return false;
      } else {
        return true;
      }
    },
    mon_count() {
      if (this.count_down === 0) {
        return false;
      } else {
        setTimeout(() => {
          if (this.count_down > 0) {
            this.count_down = this.count_down - 1;
          }
        }, 1000);
        return true;
      }
    }
  },
  methods: {
    //背景图片
    query_config() {
    //   this.$http
    //     .get(this.url.sysFunctionsIntroduce + "?code=login_bg")
    //     .then(res => {
    //       document
    //         .querySelector("body")
    //         .setAttribute(
    //           "style",
    //           " background-image:url(" +
    //             res.data.result.data[0].url +
    //             ");background-size: cover; background-repeat: no-repeat;"
    //         );
    //     });
    },
    guidance() {
      let routeUrl = this.$router.resolve({
        path: "/guidance"
      });
      window.open(routeUrl.href, "_blank");
    },
    question() {
      let routeUrl = this.$router.resolve({
        path: "/question"
      });
      window.open(routeUrl.href, "_blank");
    },
    video() {
      let routeUrl = this.$router.resolve({
        path: "/video"
      });
      window.open(routeUrl.href, "_blank");
    },
    handbook() {
      let routeUrl = this.$router.resolve({
        path: "/handbook"
      });
      window.open(routeUrl.href, "_blank");
    },
    //下载文件
    download_template1() {
      const link = document.createElement("a");
      link.href = "upload" + "file/flowChart.pdf";
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
    },
    download_template2() {
      const link = document.createElement("a");
      link.href = "upload" + "file/operation.pdf"; //操作手册
      link.setAttribute("download", "");
      document.body.appendChild(link);
      link.click();
    },
    keyupSubmit() {
      document.onkeydown = e => {
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.submit();
        }
      };
    },
    reset_close() {
      this.reset.visible = false;
      this.$refs.resetRef.resetFields();
      this.reset.data = {
        userIdentity: "",
        userInfoMobile: "",
        password: ""
      };
      this.checkpassword = "";
    },
    show_reset_password() {
      this.reset.visible = true;
    },
    reset_submit() {
      this.$refs.resetRef.validate(valid => {
        if (valid) {
          this.loading = true;
          this.reset.data.password = cryptoObj.encryptFunc(
            this.reset.data.password,
            "1234567890123456"
          );
          //post请求
          this.$http
            .post(this.url.reset_password, this.reset.data)
            .then(res => {
              this.loading = false;
              if (res.body.status == "200") {
                this.$message.success("修改密码成功，请重新登录");
                this.reset_close();
              } else {
                this.loading = false;
                this.$message.error(res.body.message);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    auth_code() {
      //验证码
      this.count_down = 60;
      let data = { mobile: this.reset.data.userInfoMobile };
      this.$http.post(this.url.sms, data, { emulateJSON: true }).then(
        res => {
          if (res.status == 200) {
            this.$message.success("发送成功");
          } else {
            this.count_down = 0;
            this.$message.error("发送失败");
          }
        },
        err => {
          this.count_down = 0;
          this.$message.error("发送失败");
        }
      );
    },
    radioChange(type) {
      this.reg = false;
      if (type == "建设单位") {
        this.loginPlaceholder = "组织机构代码";
        this.title = "建设单位网上报审";
        this.reset.title = "建设单位修改密码";
        this.url.login = this.url.censor;
        this.url.reset_password = this.url.censor_reset_password;
      } else if (type == "勘察/设计") {
        this.loginPlaceholder = "组织机构代码（公司）/手机号（个人））";
        this.title = "勘察/设计单位网上报审";
        this.url.login = this.url.design;
        this.reset.title = "勘察/设计单位修改密码";
        this.url.reset_password = this.url.censor_reset_password;
      } else {
        this.loginPlaceholder = "用户名";
        this.title = "审查机构";
        this.reset.title = "审查机构修改密码";
        this.url.login = this.url.draw;
        this.reg = true;
        this.url.reset_password = this.url.censor_reset_password;
      }
    },
    register() {
      if (this.login.type == "建设单位") {
        this.$router.push({ name: "constructionRegister" });
      } else if (this.login.type == "勘察/设计") {
        this.$router.push({ name: "designRegister" });
      } else {
        this.$router.push({ name: "constructionRegister" });
      }
    },
    submit() {
      this.$refs.loginRef.validate(valid => {
        if (valid) {
          //post请求
          this.$http
            .post(
              this.url.login,
              {
                //后续放开
                username: cryptoObj.encryptFunc(
                  this.login.username,
                  "1234567890123456"
                ),
                password: cryptoObj.encryptFunc(
                  this.login.password,
                  "1234567890123456"
                ),
                // username: this.login.username,
                // password: this.login.password,
                type: "审查机构"
              },
              { emulateJSON: true }
            )
            .then(res => {
              this.loading = false;
              if (res.data.status == "200") {
                this.$message.success("登录成功，欢迎回来");
                document
                  .querySelector("body")
                  .setAttribute("style", "background-image:url()");
                this.$store.commit("$_setStorage", { user: res.body });
                //sessionStorage.setItem("loginName", "苏州市区建设有限公司");
                this.$store.commit("$_setLogin", "300");
                this.$store.commit("$_setDraw", "监管机构");
                if (this.login.username === "13100") {
                  this.$router.push("/inspectSuperviseHome");
                } else {
                  this.$router.push("/inspectDrawHome");
                }
              } else {
                this.loading = false;
                this.$message.error(res.body.message);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style>
@import "../../../styles/css/login.css";
</style>



// WEBPACK FOOTER //
// src/views/login/xuzhou/supervise_login-xz.vue